<template>
  <div class="shouhou_page">
    <!-- 返回按钮 + 标题 -->
    <div class="nav_bar">
      <div class="back_btn" @click="goBack">‹</div>
      <div class="nav_title">售后客服</div>
    </div>

    <!-- 顶部插画区 -->
    <div class="hero">
      <img
        class="hero_img"
        :src="require('@/assets/new_adult_img/价格列表背景图.png')"
        alt=""
      />
      <div class="hero_mask"></div>
      <div class="hero_title"></div>
    </div>

    <!-- 客服卡片列表 -->
    <div class="card_list">
      <div class="phone_card" @click="call('4008280681')">
        <div class="card_icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="26" height="26">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
          </svg>
        </div>
        <div class="card_text">
          <div class="card_label">全国服务热线：</div>
          <div class="card_number">400-8280-681</div>
        </div>
        <div class="card_arrow">›</div>
      </div>

      <div class="phone_card" @click="call('18912720761')">
        <div class="card_icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="26" height="26">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
          </svg>
        </div>
        <div class="card_text">
          <div class="card_label">客服热线：</div>
          <div class="card_number">18912720761</div>
        </div>
        <div class="card_arrow">›</div>
      </div>

      <div class="phone_card" @click="call('18694938883')">
        <div class="card_icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="26" height="26">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
          </svg>
        </div>
        <div class="card_text">
          <div class="card_label">投诉电话：</div>
          <div class="card_number">18694938883</div>
        </div>
        <div class="card_arrow">›</div>
      </div>
    </div>

    <div class="tips">点击卡片可直接拨打</div>

    <AdultNewTabBar />
  </div>
</template>

<script>
import AdultNewTabBar from '@/components/AdultNewTabBar.vue'

export default {
  name: 'NewPageShouhou',
  components: { AdultNewTabBar },
  methods: {
    goBack() {
      this.$router.back()
    },
    call(phone) {
      if (confirm('确定拨打 ' + phone + ' 吗？')) {
        window.location.href = 'tel:' + phone
      }
    }
  }
}
</script>

<style scoped>
.shouhou_page {
  width: 100vw;
  min-height: 100vh;
  background: #f5f8fc;
  box-sizing: border-box;
  padding-bottom: 70px;
}

/* 顶部导航 */
.nav_bar {
  position: relative;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.back_btn {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 28px;
  color: #2c6ba5;
  font-weight: 300;
  cursor: pointer;
  line-height: 1;
}
.nav_title {
  font-size: 16px;
  font-weight: 600;
  color: #1a3c5e;
}

/* 顶部插画 */
.hero {
  position: relative;
  height: 180px;
  overflow: hidden;
}
.hero_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.hero_mask {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(245,248,252,0.9) 100%);
}
.hero_title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 20px;
  font-weight: 700;
  color: #1a3c5e;
  text-shadow: 0 2px 6px rgba(255,255,255,0.9);
}

/* 客服卡片列表 */
.card_list {
  padding: 24px 16px 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.phone_card {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #4a9bdc, #1e6ab5);
  border-radius: 12px;
  padding: 16px 18px;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(30, 106, 181, 0.25);
  transition: opacity 0.15s;
}
.phone_card:active {
  opacity: 0.85;
}
.card_icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: rgba(255,255,255,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  flex-shrink: 0;
}
.card_text {
  flex: 1;
}
.card_label {
  font-size: 13px;
  opacity: 0.9;
  margin-bottom: 4px;
}
.card_number {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.5px;
}
.card_arrow {
  font-size: 22px;
  font-weight: 300;
  opacity: 0.7;
}

.tips {
  text-align: center;
  font-size: 12px;
  color: #999;
  margin-top: 20px;
}
</style>
